export const STRIPE_API_VERSION = '2020-08-27';
